<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>confirmation_number</mat-icon></div>
          <mat-card-title>Tickets</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [showConsultarPor]="false"
          [showParametro]="true"
          labelParametro="ID"
          [(parametro)]="filtroId"
          parametroMask="separator.0"
          (consultar)="consultar()"
          (novo)="novo()">

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Segmento</mat-label>
              <mat-select [(value)]="filtroSegmento">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let s of segmentos" [value]="s.codigo">{{ s.nome }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Parceiro</mat-label>
              <mat-select [(value)]="filtroParceiroId">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let p of parceiros" [value]="p.id">{{ p.razaoSocial }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Prioridade</mat-label>
              <mat-select [(value)]="filtroPrioridade">
                <mat-option [value]="null">Todas</mat-option>
                <mat-option *ngFor="let p of prioridades" [value]="p">{{ getDescricaoPrioridade(p) }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Categoria</mat-label>
              <mat-select [(value)]="filtroCategoria">
                <mat-option [value]="null">Todas</mat-option>
                <mat-option *ngFor="let c of categorias" [value]="c">{{ getDescricaoTipoTicket(c) }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Atribuído a</mat-label>
              <mat-select [(value)]="filtroAtribuidoId">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let u of atribuicoes" [value]="u.id">{{ u.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="wow-consulta__campo">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Status</mat-label>
              <mat-select [(value)]="filtroStatus">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let st of statusOpcoes" [value]="st">{{ getDescricaoStatusTicket(st) }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Informe os filtros (opcional) e clique em <strong>Consultar</strong>.
        </div>

        <div *ngIf="consultaRealizada">
          <table mat-table [dataSource]="tickets" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let ticket">{{ ticket.id }}</td>
            </ng-container>
            <ng-container matColumnDef="segmento">
              <th mat-header-cell *matHeaderCellDef>Segmento</th>
              <td mat-cell *matCellDef="let ticket">{{ labelSegmento(ticket.segmento) }}</td>
            </ng-container>
            <ng-container matColumnDef="responsavel">
              <th mat-header-cell *matHeaderCellDef>Responsável</th>
              <td mat-cell *matCellDef="let ticket">{{ nomeResponsavel(ticket) }}</td>
            </ng-container>
            <ng-container matColumnDef="assunto">
              <th mat-header-cell *matHeaderCellDef>Assunto</th>
              <td mat-cell *matCellDef="let ticket">{{ ticket.menu }}</td>
            </ng-container>
            <ng-container matColumnDef="categoria">
              <th mat-header-cell *matHeaderCellDef>Categoria</th>
              <td mat-cell *matCellDef="let ticket">{{ getDescricaoTipoTicket(ticket.tipo) }}</td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let ticket">{{ getDescricaoStatusTicket(ticket.status) }}</td>
            </ng-container>
            <ng-container matColumnDef="dataCriacao">
              <th mat-header-cell *matHeaderCellDef>Data Criação</th>
              <td mat-cell *matCellDef="let ticket">{{ ticket.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
            </ng-container>
            <ng-container matColumnDef="dataPrevisaoEntrega">
              <th mat-header-cell *matHeaderCellDef>Previsão Entrega</th>
              <td mat-cell *matCellDef="let ticket">{{ ticket.dataPrevisaoEntrega | date:'dd/MM/yyyy HH:mm' }}</td>
            </ng-container>
            <ng-container matColumnDef="editar">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let ticket" (click)="$event.stopPropagation()">
                <button mat-icon-button color="accent" matTooltip="Alterar" (click)="editar(ticket.id)">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>
          <mat-paginator [length]="totalElementos" [pageSize]="tamanho" [pageSizeOptions]="pageSizeOptions"
            (page)="paginar($event)">
          </mat-paginator>
        </div>
      </mat-card>
    </div>
  </div>
</main>
